export default "__VITE_ASSET__DUoPvM9o__"